export const PERMISSIONS = {
  CREATE_TICKETS: "create_tickets",
  CLOSE_TICKETS: "close_tickets",
  MANAGE_CUSTOMERS: "manage_customers",
  MANAGE_CONTACT_REASONS: "manage_contact_reasons",
  MANAGE_COMMUNICATION_METHODS: "manage_communication_methods",
  MANAGE_SHORT_SUBJECTS: "manage_short_subjects",
  MANAGE_BRANCHES: "manage_branches",
  MANAGE_PRODUCTS: "manage_products",
  MANAGE_DEPARTMENTS: "manage_departments",
  MANAGE_USERS: "manage_users",
  VIEW_REPORTS: "view_reports",
  DOWNLOAD_ATTACHMENTS: "download_attachments",
  REPLY_TICKETS: "reply_tickets",
  CLASSIFY_TICKETS: "classify_tickets",
  EDIT_TICKETS: "edit_tickets",
  VIEW_ACTIVITY_LOG: "view_activity_log",
  DELETE_REPLY: "delete_reply",
  EXPORT_TICKETS: "export_tickets",
  MANAGE_ACTION_TYPES: "manage_action_types",
  MANAGE_EMPLOYEES: "manage_employees",
  ADD_REPLY_ACTION: "add_reply_action",
  DELETE_REPLY_ACTION: "delete_reply_action",
  VIEW_ACTIONS_REPORT: "view_actions_report",
  EXPORT_ACTIONS_REPORT: "export_actions_report",
};

export const ROUTE_PERMISSIONS = {
  "/create-ticket": PERMISSIONS.CREATE_TICKETS,
  "/customers": PERMISSIONS.MANAGE_CUSTOMERS,
  "/contact-reasons": PERMISSIONS.MANAGE_CONTACT_REASONS,
  "/communication-methods": PERMISSIONS.MANAGE_COMMUNICATION_METHODS,
  "/short-subjects": PERMISSIONS.MANAGE_SHORT_SUBJECTS,
  "/branches": PERMISSIONS.MANAGE_BRANCHES,
  "/products": PERMISSIONS.MANAGE_PRODUCTS,
  "/departments": PERMISSIONS.MANAGE_DEPARTMENTS,
  "/users": PERMISSIONS.MANAGE_USERS,
  "/reports": PERMISSIONS.VIEW_REPORTS,
  "/activity-log": PERMISSIONS.VIEW_ACTIVITY_LOG,
  "/action-types": PERMISSIONS.MANAGE_ACTION_TYPES,
  "/employees": PERMISSIONS.MANAGE_EMPLOYEES,
  "/actions-report": PERMISSIONS.VIEW_ACTIONS_REPORT,
};

export const hasPermission = (permissions, perm) =>
  Array.isArray(permissions) && permissions.includes(perm);

export const canAccessRoute = (permissions, path) => {
  if (/^\/tickets\/\d+\/edit$/.test(path)) {
    return hasPermission(permissions, PERMISSIONS.EDIT_TICKETS);
  }

  const required = ROUTE_PERMISSIONS[path];
  if (!required) {
    return true;
  }
  return hasPermission(permissions, required);
};
